import { GET_PROGRAM_INVENTORY, GET_PROGRAM_INVENTORY_SUCCESS, GET_PROGRAM_INVENTORY_ERROR, GET_PROGRAM_INVENTORY_EMPTY } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetProgramInventory = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRAM_INVENTORY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_INVENTORY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_INVENTORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PROGRAM_INVENTORY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetProgramInventory;
